var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Player',_vm._b({ref:"player",attrs:{"theme":"dark"}},'Player',_vm.$attrs,false),[_c('Video',{attrs:{"crossOrigin":"","poster":_vm.cover}},[_c('source',{attrs:{"data-src":_vm.src,"type":"video/mp4"}})]),_vm._v(" "),_c('DefaultUi')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }